/* eslint-disable no-unused-vars */
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import { Field } from '../../resurs-props/field/field';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { ResursTreeApi } from '../../../services/modules/tree';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../services/types/store-types';
import { IDialogParams } from '../api/types/dialog.interface';

export const CommandParameterDialog = ({
  show,
  close,
  params,
}: IDialogParams<any>) => {
  const { register, control, getValues } = useForm();
  const lastSelect = useSelector(
    (state: RootState) => state.tree.selectedNodes
  );
  const dispatch = useAppDispatch();
  const [paramAttributes, setParamAttributes] = useState<{
    [key: string]: any;
  }>({});

  /**
   * Начиная с версии 4.8
   * Мы собираем параметры команды в массив
   * Нужно для более расширенной настройки параметров
   */
  const compactParametersIntoArray = (values: any) => {
    return Object.keys(values).map((key) => ({
      [key]: values[key],
      ...paramAttributes[key],
    }));
  };

  const execute = () => {
    if (lastSelect && lastSelect.tree && lastSelect.objectIds) {
      const requestData = getValues();
      for (const key in requestData) {
        if (key === 'field_На момент (дата)') {
          const date = new Date(requestData[key] * 1000);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          const formatDate = `${day}.${month}.${year}`;
          requestData[key] = formatDate;
        }
      }
      ResursTreeApi.execObjectCommand({
        tree: lastSelect.tree,
        objectId: lastSelect.objectIds,
        command: params.key,
        parameterList: compactParametersIntoArray(requestData),
        // treeNeighbor: treeNeighboor,
      }).then(() => {
        close();

        dispatch(
          ResursTreeApi.getPropertysRedux({
            tree: lastSelect.tree!,
            objects: lastSelect.objectIds.map((item: any) => Number(item)),
          })
        );
      });
    }
  };

  const labels = params.parameterList?.map(
    (item: any) => item.templateOptions.label
  );
  const longestStr = labels?.reduce(
    (max: any, n: any) => (max.length > n.length ? max : n),
    ''
  );

  const values = params.parameterList?.map((item: any) => item.defaultValue);
  const longestValues = values?.reduce(
    (max: any, n: any) => (String(max).length > String(n).length ? max : n),
    ''
  );

  const change = (arg: any, arg2: any) => {
    console.info('');
  };

  const changeAttribute = (param: string, attributes: any) => {
    setParamAttributes((prev) => ({
      ...prev,
      [param]: attributes,
    }));
  };

  return (
    <Dialog
      dismissableMask
      visible={show}
      onHide={close}
      header={params.label}
      style={{ width: 'auto' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {params &&
          params.parameterList &&
          params.parameterList.map((param: any, idx: number) => (
            <Field
              prop={
                params.key === 'key_10' ? { ...param, type: 'file' } : param
              }
              reg={register}
              control={control}
              change={change}
              changeAttribute={changeAttribute}
              uid={idx}
              labelWidth={longestStr ? longestStr.length * 18 * 0.7 : undefined}
              valueWidth={
                longestValues
                  ? longestValues.toString().length * 18 * 0.7
                  : undefined
              }
            />
          ))}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            justifyContent: 'end',
          }}
        >
          <Button onClick={execute} size='small' autoFocus label="Выполнить" />
          <Button onClick={close} size='small' severity="secondary" label="Отмена" />
        </div>
      </div>
    </Dialog>
  );
};
